module.exports = __webpack_public_path__ + "media/images/admin/icons/command-2531129b1ccfa8584252aceb63a2f08e.svg";